import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfCalgary = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Calgary"
      universityShortName="U of C"
      slug="university-of-calgary"
      seoTitle="University of Calgary Study Rooms | TFDL Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Calgary. Find TFDL workrooms, VR rooms, and treadmill desks. Plus free 24/7 online alternative."
      seoKeywords="university of calgary study rooms, tfdl, taylor family digital library, calgary university library, ucalgary study spaces"
      canonicalUrl="/study-room/university-of-calgary/"
      heroDescription="A comprehensive guide to study rooms at U of C, including the high-tech Taylor Family Digital Library (TFDL)."
      libraryWebsiteUrl="https://library.ucalgary.ca/"
      libraryWebsiteName="U of C Library"
      studySpaces={[
        {
          name: "Taylor Family Digital Library (TFDL) - Student Workrooms",
          features: "Bookable student workrooms for group study and collaboration.",
          feedback: "High demand for rooms; strict booking rules apply."
        },
        {
          name: "Digital Media Suites",
          features: "Equipped for presentations, video calls, and multimedia work.",
          feedback: "Ideal for presentations; must be booked in advance."
        },
        {
          name: "High-Performance PC Clusters",
          features: "Powerful computers for demanding academic work.",
          feedback: "Popular with students needing computing power."
        },
        {
          name: "VR Rooms",
          features: "Virtual reality equipment for immersive learning experiences.",
          feedback: "Students praise the high-tech amenities; unique offering."
        },
        {
          name: "Treadmill Desks",
          features: "Walking desks for active studying.",
          feedback: "Popular novelty; can be noisy for neighbors."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Use the <strong>occupancy webpage</strong> to find quiet areas; <strong>TFDL's top floors</strong> are generally hushed. For presentations or video calls, the <strong>digital media suites</strong> are ideal.
          </p>
          <p className="mb-4">
            Study-room bookings are limited to academic use, cannot be left unattended, and are <strong>forfeited if unoccupied after 10 minutes</strong>. The three-hour maximum means long study sessions require finding other spaces.
          </p>
          <p>
            Arrive on time—no-show bookings are cancelled after 10 minutes.
          </p>
        </>
      }
      summaryTips={[
        "Check occupancy online: TFDL provides real-time occupancy data to find quiet areas.",
        "Arrive on time: Bookings are cancelled after 10 minutes if unoccupied.",
        "Try the VR rooms: Unique amenity for immersive learning experiences.",
        "Use treadmill desks for active study: Walk while you work (but be mindful of noise).",
        "Use CSW for longer sessions: Three-hour booking limit means virtual rooms are great for extended study."
      ]}
    />
  );
};

export default UniversityOfCalgary;
